module.exports = __webpack_public_path__ + "img/1-en.36b1bfe2.jpg";